'use client';

import { createContext } from 'react';

import type { PropertyCardRootContextInterface } from '../types/property-card-root.types';

export const PropertyCardRootContext = createContext<PropertyCardRootContextInterface>({});

PropertyCardRootContext.displayName = 'PropertyCard.Root.Context';
